module.exports = __webpack_public_path__ + "static/media/status-gift-card.6456be4b.svg";